export default "__VITE_PUBLIC_ASSET__57c1ce0d__"